import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Developer from "./DeveloperV2";
import "./styles.css";
import "./developer.css";

const isDeveloperPage = window.location.pathname.startsWith("/developer");
document.title = isDeveloperPage
  ? "Developer Underwriting Room | Ananda Village"
  : "Ananda Village | Investor Feasibility Study";
const page = isDeveloperPage ? <Developer /> : <App />;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>{page}</React.StrictMode>,
);
